import React from "react";
import { Table } from "react-bootstrap";
import Loader from "../../../../../../shared-library/components/Loader";
var FamilyTaggingDetailsPopUp = function (props) {
    var _a, _b;
    var columnList = [
        {
            title: "Account Name",
            key: "accountName",
        },
        {
            title: "Account Code",
            key: "accountCode",
        },
        {
            title: "Status",
            key: "status",
        },
        {
            title: "Relation",
            key: "relation",
        },
    ];
    return (React.createElement("div", { className: "pop-up-container" }, (props === null || props === void 0 ? void 0 : props.loader) ? (React.createElement("div", { className: "border-0 loader-height-row w-100" },
        React.createElement("div", { className: "position-relative loader-lead border-0" },
            React.createElement(Loader, null)))) : ((_a = props === null || props === void 0 ? void 0 : props.tbodyData) === null || _a === void 0 ? void 0 : _a.length) > 0 ? (React.createElement(Table, null,
        React.createElement("thead", null,
            React.createElement("tr", null, columnList.map(function (column, idx) {
                return React.createElement("th", { key: idx }, column.title);
            }))),
        React.createElement("tbody", null, (_b = props === null || props === void 0 ? void 0 : props.tbodyData) === null || _b === void 0 ? void 0 : _b.map(function (val, idx) { return (React.createElement("tr", { key: idx },
            React.createElement("td", null, val === null || val === void 0 ? void 0 : val.name),
            React.createElement("td", null, val === null || val === void 0 ? void 0 : val.accode),
            React.createElement("td", null, val === null || val === void 0 ? void 0 : val.status),
            React.createElement("td", null, val === null || val === void 0 ? void 0 : val.relation))); })))) : (React.createElement("div", { className: "no-data-block" },
        React.createElement("span", { className: "icon-class" },
            React.createElement("i", { className: "edel-icon-report-excla" },
                React.createElement("span", { className: "path1" }),
                React.createElement("span", { className: "path2" }),
                React.createElement("span", { className: "path3" }))),
        React.createElement("span", { className: "error-text" }, "No family tagging was found for this account")))));
};
export default FamilyTaggingDetailsPopUp;
